<template>
  <el-dialog
    title="登录"
    :visible.sync="loginDia"
    :close-on-click-modal="false"
    custom-class="login-dialog"
    >
    <div class="login-form-box">
      <div class="login-type-box">
        <div class="item left-item" :class="{active: type == 'show'}" @click="type = 'show'">应用版</div>
        <div class="item right-item" :class="{active: type == 'shot'}" @click="type = 'shot'">卖家版</div>
      </div>
      <div class="login-form-wrap">
        <el-form :model="loginForm" :rules="loginFormrules" ref="loginForm" class="login-form mt20">
          <el-form-item prop="email">
            <el-input placeholder="用户名" v-model="loginForm.email"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input placeholder="密码" type="password" v-model="loginForm.password"></el-input>
          </el-form-item>
          <el-form-item prop="remember">
            <el-checkbox-group v-model="loginForm.remember">
              <el-checkbox label="5天内自动登录" :value="1"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="mt20" @click="login">登    录</el-button>
        <div class="blue-link" @click="forgetPass">忘记密码</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { shotUrl, showUrl } from '@/filters'
export default {
  name: 'loginDia',
  data () {
    return {
      loginDia: false,
      type: 'show',
      loginForm: {
        email: '',
        password: '',
        rememberData: 0,
        remember: 0
      },
      loginFormrules: {
        email: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    login () {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          let params = this.loginForm
          params.type = this.type
          this.$api.login(params).then(res => {
            if (res.code === '0') {
              this.$cookie.saveCookies(res.data)
              this.$store.commit('saveUserInfo', res.data)
              this.loginDia = false
              setTimeout(() => {
                window.location.href = window.location.href
              }, 1000)
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
    forgetPass () {
      let host = shotUrl
      if (this.type === 'show') {
        host = showUrl
      }
      let url = `${host}/resetpwd/phone`
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .login-dialog {
    .login-form-box {
      margin: 30px auto 0 auto;
      .login-type-box {
        display: flex;
        width: 390px;
        margin: auto;
        .item {
          width:193px;
          height:36px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(0,0,0,0.12);
          line-height: 36px;
          text-align: center;
          cursor: pointer;
        }
        .left-item {
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
        }
        .right-item {
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
        }
        .active {
          background:rgba(241,90,63,0.11);
          font-weight:500;
          color:rgba(0,0,0,0.87);
        }
      }
    }
    .login-form-wrap {
      width: 340px;
      margin: auto;
      margin-top: 30px;
      .login-form {
        width: 340px;
        margin: auto;
        .el-form-item {
          margin-top: 20px;
        }
      }
      .el-button {
        width: 340px;
      }
      .blue-link {
        cursor: pointer;
        margin-top: 10px;
        padding-bottom: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/loginDia.vue